import React from "react";

function CardsItems() {
  return (
    <div className="cards_items">
      <div className="item wow fadeInUp">
        <div className="icon">
          <img src="./images/card1.svg" alt="" />
        </div>
        <p className="pt f_40">Designed by Industry Insiders </p>
        <div className="des">
          Actionable feedback from{" "}
          <span className="color_red">decision-makers</span> at the firms you’re
          applying to.
        </div>
      </div>
      <div className="item wow fadeInUp" style={{ animationDelay: "100ms" }}>
        <div className="icon">
          <img src="./images/card2.png" alt="" />
        </div>
        <p className="pt f_40"> Faster Offer Turnaround</p>
        <div className="des">
          Users who completed <span className="color_blue">10+</span> mock
          sessions with WeKruit received{" "}
          <span className="color_blue">5x faster offer rate</span> compared to
          traditional prep services
        </div>
      </div>
      <div className="item wow fadeInUp" style={{ animationDelay: "200ms" }}>
        <div className="icon">
          <img src="./images/card3.png" alt="" />
        </div>
        <p className="pt f_40">Boosted Your Confidence</p>
        <div className="des">
          <span className="color_yellow"> 97%</span> of users feel more prepared
          and clear on how to improve for their future interview.
        </div>
      </div>
    </div>
  );
}

export default CardsItems;
